<!--suppress ALL -->
<template lang="pug">
#grupos-alerta(
    :style='{ height: this.altura + "px" }',
    :class='[isHorizontal ? "noBoxShadow" : ""]'
)
    div(
        :class='[isHorizontal ? "btn-group-horizontal" : "btn-group-vertical"]'
    )
        transition-group(
            tag='ul',
            v-bind:css='false',
            :class='[isHorizontal ? "ul-flex" : ""]',
            @leave='leave',
            @enter='enter'
        )
            grupo-alerta(
                v-if='!grupoAtivo.flag || grupoAtivo.index == index',
                v-for='(grupoAlerta, index) in gruposAlerta',
                @click='isHorizontal ? showModalAlerta(grupoAlerta) : showAlerta(index)',
                :icon-class='getIcone(grupoAlerta.id)',
                :class='{ focus: grupoAtivo.index != index }',
                :isHorizontal='isHorizontal',
                :quantidade='grupoAlerta.alertas.length',
                :titulo='grupoAlerta.nome',
                :key='grupoAlerta.id',
                :alertas='grupoAlerta.alertas'
            )

    .box-alert(v-if='grupoAtivo.flag')
        alerta(
            v-for='alerta in gruposAlerta[grupoAtivo.index].alertas',
            :key='alerta.id',
            :alerta='alerta'
        )

    #alertas.row(v-if='dialogVisible')
        el-dialog(
            :visible.sync='dialogVisible',
            width='750px',
            :before-close='handleCloseModalAlerta'
        )
            span(v-if='grupoAlerta', slot='title') {{ grupoAlerta.nome }}

            div(v-if='grupoAlerta')
                el-table(
                    v-if='grupoAlerta.alertas && grupoAlerta.alertas.length > 0',
                    :data='grupoAlerta.alertas',
                    style='width: 100%'
                )
                    el-table-column(
                        prop='tipo.nome',
                        label='Alerta',
                        width='600'
                    )
                    el-table-column(
                        :formatter='formatDataPtBr',
                        label='Data',
                        width='100'
                    )

                empty-result(
                    v-else,
                    :message='"Nenhum alerta emitido"',
                    iconClass='mdi-bell-alert-outline'
                )

            span.dialog-footer(slot='footer')
                el-button(@click='handleCloseModalAlerta') Cancelar

    ModalAlertasSocioambientais(
        :show='showModalAlertasSocioambientais',
        @close='closeModalAlertasSocioambientais'
    )
</template>

<script>
import GrupoAlerta from './GrupoAlerta';
import Alerta from './Alerta';
import { GROUP_ICONS } from '@/utils/helpers/icon-mapper';
import Velocity from 'velocity-animate/velocity.min.js';
import EmptyResult from '@/components/EmptyResult';
import ModalAlertasSocioambientais from '@/components/alertas/ModalAlertasSocioambientais';

export default {
    name: 'GruposAlerta',
    props: {
        gruposAlerta: {
            type: Array,
            required: true
        },
        altura: {
            type: Number,
            required: true
        },
        isHorizontal: {
            type: Boolean
        }
    },

    data() {
        return {
            grupoAtivo: {
                flag: false,
                index: Number
            },
            dialogVisible: false,
            showModalAlertasSocioambientais: false
        };
    },

    components: {
        GrupoAlerta,
        Alerta,
        EmptyResult,
        ModalAlertasSocioambientais
    },

    methods: {
        getIcone(idIcone) {
            return GROUP_ICONS[idIcone];
        },
        showAlerta(id) {
            this.grupoAtivo.flag = !this.grupoAtivo.flag;
            this.grupoAtivo.index = id;
        },
        leave(el, done) {
            if (!this.isHorizontal) {
                var delay = 0;
                setTimeout(() => {
                    Velocity(
                        el,
                        {
                            'padding-top': '0px',
                            'padding-bottom': '0px',
                            height: '0px',
                            'min-height': '0px',
                            opacity: 0
                        },
                        { duration: 200, complete: done }
                    );
                }, delay);
            }
        },
        enter(el, done) {
            if (!this.isHorizontal) {
                var delay = 0;
                setTimeout(() => {
                    Velocity(
                        el,
                        { height: this.altura / 4 + 'px', opacity: 1 },
                        { duration: 200, complete: done }
                    );
                }, delay);
            }
        },
        showModalAlerta(grupoAlerta) {
            if (grupoAlerta.nome === 'Alertas socioambientais') {
                this.showModalAlertasSocioambientais = true;
            } else {
                this.dialogVisible = true;
                this.grupoAlerta = grupoAlerta;
            }
        },
        closeModalAlertasSocioambientais() {
            this.showModalAlertasSocioambientais = false;
        },
        handleCloseModalAlerta(done) {
            this.dialogVisible = false;
        },
        formatDataPtBr(data) {
            return new Date(data.dataCadastro).toLocaleDateString('pt-BR');
        }
    }
};
</script>

<style lang="scss" scoped>
#grupos-alerta {
    overflow: hidden;
    @include default-box-shadow();

    .menu-alerta {
        overflow-y: overlay;
        padding-right: 0 !important;
    }

    .focus {
        height: 0px;
    }

    .btn-group-vertical {
        width: 100%;
        position: relative;
    }

    .btn-group-horizontal {
        display: flex;
        flex-direction: row;
        position: relative;
    }

    .ul-flex {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .box-alert {
        @include scroll-bar();
        width: 100%;
        height: calc(625px - 157px);
        background-color: var(--white);
        border-style: solid;
        border-color: var(--default-border-color);
        border-width: 0 1px 1px 1px;
        background-color: var(--white);
        overflow: auto;
    }

    ul {
        width: 100%;
        margin: 0;
        padding: 0;
    }
}
.noBoxShadow {
    box-shadow: none !important;
}

#alertas {
    .card-alertas {
        width: 25%;
        background-color: var(--white);
        padding: 15px;
        margin-right: 15px;
        margin-bottom: 15px;
        border-radius: 5px;
        border: solid 1px var(--default-border-color);
        display: flex;
        cursor: pointer;
    }

    .card-alertas:last-child {
        margin-right: 0;
    }

    .last {
        margin-right: 0;
    }

    .alert-icon {
        color: #01a3a4;
        font-size: 24px;
        margin-right: 10px;
        padding-top: 5px;
    }

    .message-body {
        min-height: 200px;
    }
}
</style>
